import React from 'react';
import {
  FacultyProfileData,
  ProfileDataProps
} from '../screens/FacultyProfile/FacultyProfileData';
import { BoundaryProps, cleanProps, genPathTo } from './Boundary';
import { useQueryParams } from '../hooks/useQueryParams';
import { FacultyProfileFormData } from '../screens/FacultyProfile/FacultyProfileFormData';
import { featureFlags } from '../../frontendBackend';

const path = 'profile-data';

export interface ProfileDataBoundaryProps
  extends BoundaryProps,
    ProfileDataProps {}

export const FacultyProfileDataBoundary: React.FC<ProfileDataBoundaryProps> = props => {
  props = cleanProps(props);

  const [callbackOrigin] = useQueryParams().callbackOrigin;
  const isInIframe = window.backend?.inIframe || (window as any).__inIframeTest;

  return ( 
    <div>
      {!isInIframe && featureFlags.isUseStandaloneProfileForm() ? <FacultyProfileFormData callbackOrigin={callbackOrigin} {...props} /> : <FacultyProfileData callbackOrigin={callbackOrigin} {...props} />}
    </div>
  );
};

export interface SupportedPathOptions {
  // Currently no options (all props are non-url)
}

export const pathTo = genPathTo<SupportedPathOptions>('/' + path);

FacultyProfileDataBoundary.defaultProps = {
  path
};
